import TimeSteps from '../../enums/TimeSteps';
import mockedRequester from './mockedRequester';
export const mockedPreferences = {
    dashboard: { irrigation: { chart: { periodId: 'last_30_days', timeStep: TimeSteps.perHours } } }
};
const mock = {
    delete: mockedRequester(undefined, 'preferences.delete'),
    get: mockedRequester(mockedPreferences, 'preferences.get'),
    update: mockedRequester(undefined, 'preferences.update')
};
export default mock;
